import {IRouteProps} from "../../../ts/manager/view/ViewInterface";
import {PostType} from "../../../ts/manager/post/PostManager";
import {getManager} from "../../../ts/manager/Manager";
import React from "react";
import {getModelFactory} from "../../../ts/model-factory/ModelFactory";
import StateViewController from "../../vc/StateViewController";
import {assert} from "../../../ts/common/Assert";
import RouteChoice from "../../../ts/model-factory/basic/route/RouteChoice";
import PostContentView from "./partial/PostContentView";
import {PostListRouteModel} from "../../../ts/route/subject/PostListRouteFactory";
import NavRelatedPostsView from "../../partial/nav/NavRelatedPostsView";
import DataModel from "../../../ts/model-factory/basic/data/DataModel";
import {isNumeric} from "../../../ts/common/SiteHelper";

const PostPage = (props:IRouteProps) =>
{
    const postType:PostType = getManager().navigation.model.routeIDs.post_type ?? "organisation"
    let organisationID = getManager().user.organisationID;

    let postID = getManager().navigation.model.routeIDs.post_id ?? 0;
    let postChoice = postID ? (getModelFactory().postData.getSharedDataModel(postType)?.choices[postID] ?? null) : null;
    let dataModels:DataModel|null = null;
    if(!postChoice){
        if(!postID){
            if(isNumeric(getManager().navigation.model.routeIDs.post_list_route_id)){
                postID = parseInt(getManager().navigation.model.routeIDs.post_list_route_id ?? "0");
            }
        }
        if(postID){
            postChoice = getModelFactory().postData.getSharedDataModel(postType)?.choices[postID] ?? null;
            if(!postChoice){
                dataModels = getModelFactory().postData.getEntryDataModel(postType, postID);
            }
        }
    }

    const viewState = StateViewController({
        routeProps: props,
        dataModels: dataModels,
        assert: postChoice
    })

    if(viewState.overrideView){
        return viewState.overrideView;
    }

    assert(postChoice)

    let relatedPostsRouteModel:PostListRouteModel|null = null;
    if((postChoice.postStatus === "publish") && ((postType === "project" ) || (postType === "offer"))){
        relatedPostsRouteModel = getModelFactory().postListRoute.getDefaultModel(postType, false);
    }


    const organisationChoice = postChoice?.getParentChoice() ?? null;
    const organisationRouteChoice = organisationChoice ? getModelFactory().getEntryRouteChoice("organisation", organisationChoice.postID) : null
    organisationID = postChoice.organisationID ? postChoice.organisationID : organisationID;
    let editChoice:RouteChoice|null  = null;
    let applicationsChoice:RouteChoice|null  = null;
    if(organisationID && (organisationID === getManager().user.organisationID)){
        editChoice = getModelFactory().getEntryRouteChoice(postType, postID, true);
        applicationsChoice = getModelFactory().postEntryRoute.getDefaultModel(postType, postID)?.choices.applications ?? null
    }
    return <>
        <PostContentView
            routeProps={props}
            postChoice={postChoice}
            editChoice={editChoice}
            applicationsChoice={applicationsChoice}
            organisationChoice={organisationChoice}
            organisationRouteChoice={organisationRouteChoice}
        />
        {!!relatedPostsRouteModel && <>
            <NavRelatedPostsView
                routeProps={props}
                routeModel={relatedPostsRouteModel}
                title={"More "+getManager().post.config[postType].plural}
            />
        </>}
    </>
}

export default PostPage;